<template>
  <div v-show="anyNotesOrTodos" class="sf-below-4">
    <div class="sf-font-l sf-title sf-pad-l-3 sf-below-2">
      <a :href="url" :title="caption">{{ caption }}</a>
    </div>
    <div v-if="supportsCommunicationsRework">
      <RemarkV2
        v-for="remark in sortedNotes"
        :key="remark.id"
        :remark="remark"
        show-tags
      ></RemarkV2>
      <RemarkV2
        v-for="remark in sortedPendingTodos"
        :key="remark.id"
        :remark="remark"
        show-tags
      ></RemarkV2>
    </div>
    <div v-else>
      <remark-card
        v-for="remark in sortedNotes"
        :key="remark.id"
        :show-context="false"
        v-bind="remark"
      ></remark-card>
      <remark-card
        v-for="remark in sortedPendingTodos"
        :key="remark.id"
        :show-context="false"
        v-bind="remark"
      ></remark-card>
    </div>
    <div v-if="sortedCompletedTodos.length">
      <div class="sf-align-c sf-below-3">
        <div class="sf-btn sf-btn-small" @click="toggleCompletedTodos">
          {{
            I18n.t(
              'communication.todos.toggle_completed.' + showingCompletedTodos,
              { count: sortedCompletedTodos.length }
            )
          }}
        </div>
      </div>
    </div>
    <div v-if="supportsCommunicationsRework">
      <RemarkV2
        v-for="remark in filteredSortedCompletedTodos"
        :key="remark.id"
        :remark="remark"
        show-tags
      ></RemarkV2>
    </div>
    <div v-else>
      <remark-card
        v-for="remark in filteredSortedCompletedTodos"
        :key="remark.id"
        :show-context="false"
        v-bind="remark"
      ></remark-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters, mapState } from 'vuex'

import RemarkCard from '../remarks/remark-card'
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'

export default {
  components: {
    RemarkCard,
    RemarkV2,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    filter: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {
      supportsCommunicationsRework:
        Silverfin.currentFirmFeatures.supports_communications_rework,
    }
  },

  computed: {
    ...mapGetters(['notesByContext', 'todosByContext']),

    ...mapState({
      showingCompletedTodos: (state) => state.ui.showingCompletedTodos,
    }),

    anyNotesOrTodos() {
      return this.sortedNotes.length + this.sortedTodos.length
    },
    filteredSortedCompletedTodos() {
      if (!this.showingCompletedTodos) {
        return []
      }

      return this.sortedCompletedTodos
    },
    sortedNotes() {
      const unfiltered = _.orderBy(
        this.notesByContext({ type: this.type, id: this.id }),
        ['sticky', 'lastCommentedAt'],
        ['desc', 'desc']
      )
      switch (this.filter) {
        case 'all':
          return unfiltered
        case 'todos':
          return []
        case 'following':
          return this.filterFollowing(unfiltered)
        default:
          return unfiltered
      }
    },

    sortedTodos() {
      const unfiltered = _.orderBy(
        this.todosByContext({ type: this.type, id: this.id }),
        ['sticky', 'lastCommentedAt'],
        ['desc', 'desc']
      )
      switch (this.filter) {
        case 'all':
        case 'todos':
          return unfiltered
        case 'following':
          return this.filterFollowing(unfiltered)
        default:
          return unfiltered
      }
    },

    sortedCompletedTodos() {
      return this.sortedTodos.filter((todo) => todo.done)
    },

    sortedPendingTodos() {
      return _.without(this.sortedTodos, ...this.sortedCompletedTodos)
    },
  },

  methods: {
    ...mapActions([
      // TODO: We should probably move the show/hide completed todos/checklist state from the store to here (it's local state)
      'toggleCompletedTodos',
    ]),

    filterFollowing(unfilteredRemarks) {
      const currentUserId = parseInt(Silverfin.currentUserId())
      return unfilteredRemarks.filter((remark) =>
        remark.followerIds.includes(currentUserId)
      )
    },
  },
}
</script>
